import { motion, useAnimate, type AnimationSequence } from 'framer-motion'
import { useEffect } from 'react'
import { useTranslate } from '../../../../hooks/language/use-translate'
import { useGlobalStore } from '../../../../store/global-store'
import type { PositionReturnLuck } from '../../../../store/live/live-notify'
import type { NotifyLuckEarned } from '../../../../types/lives/notifies'
import blue from '../assets/blue.png'
import gold from '../assets/gold.png'
import pink from '../assets/pink.png'
import prata from '../assets/prata.png'
import purpleDark from '../assets/purple-dark.png'
import red from '../assets/red.png'

interface Props {
  toast: NotifyLuckEarned
  position: PositionReturnLuck
}

// contorno escuro -> texto branco fica legível em qualquer badge (prata claro ou escuros)
const textOutline = {
  textShadow:
    '-1px -1px 0 rgba(0,0,0,0.9), 1px -1px 0 rgba(0,0,0,0.9), -1px 1px 0 rgba(0,0,0,0.9), 1px 1px 0 rgba(0,0,0,0.9), 0 2px 3px rgba(0,0,0,0.55)',
} as const

export function Toast({ toast }: Props) {
  const remove = useGlobalStore((state) => state.removeNotifyGiftLuck)

  const [scope, animate] = useAnimate()

  const { translate } = useTranslate()

  useEffect(() => {
    const sequence: AnimationSequence = [
      [scope.current, { scale: 1, opacity: 1 }, { duration: 1 }],
      [scope.current, { opacity: 0 }, { duration: 2, delay: 1 }],
    ]

    if (toast) {
      animate(sequence).then(() => remove(toast.id))
    }
  }, [toast, scope, animate, remove])

  let imgBackground = blue

  const rt = Number(toast.returnTimes) || 0

  if (rt < 50) {
    // prata (silver) — retornos pequenos (< 50x)
    imgBackground = prata
  } else if (rt < 101) {
    imgBackground = blue
  } else if (rt < 251) {
    imgBackground = pink
  } else if (rt < 501) {
    imgBackground = purpleDark
  } else if (rt < 1000) {
    imgBackground = red
  } else {
    // 1000x ou acima = dourado
    imgBackground = gold
  }

  return (
    <motion.div
      ref={scope}
      className="flex flex-col justify-center items-center gap-10 opacity-0 relative"
      style={{ scale: 0.3 }}
    >
      <div
        className="rounded-full w-40 h-40 flex justify-center items-center relative"
        style={{
          backgroundImage: `url(${imgBackground})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'contain',
        }}
      >
        <div className="flex flex-col absolute items-center justify-center">
          <span className="text-[10px] font-bold text-white mt-4" style={textOutline}>
            WIN Coins
          </span>

          <span className="text-base font-extrabold text-white" style={textOutline}>
            {toast?.returnValues}
          </span>
        </div>

        <div className="flex flex-col items-center justify-center absolute bottom-5">
          <span className="text-[10px] font-bold text-white" style={textOutline}>
            {translate('return-value-luck-you-won')}
          </span>

          <span className="text-[10px] font-bold leading-none text-white" style={textOutline}>
            {toast.returnTimes}{' '}
            <span className="text-white leading-none">
              {translate('return-value-luck-times-game')}
            </span>
          </span>
        </div>
      </div>
    </motion.div>
  )
}
